import Layout from "./Layout";

import "./App.css";

const App = () => {
  return (
    <div className="App">
      <Layout />
    </div>
  );
};

export default App;
